/**
 * Colección destacada — revela el título y las tarjetas con un fundido
 * hacia arriba al hacer scroll, y controla las flechas del slider.
 */
(function () {
  'use strict';

  function initReveal(section) {
    if (!section.classList.contains('fc-barber--reveal')) return;

    var targets = section.querySelectorAll('[data-fc-line], [data-fc-card]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initSlider(section) {
    var track = section.querySelector('[data-fc-track]');
    var prevBtn = section.querySelector('[data-fc-prev]');
    var nextBtn = section.querySelector('[data-fc-next]');
    if (!track || !prevBtn || !nextBtn) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('.fc-card'));
    var tickingActive = false;

    function step() {
      var card = track.querySelector('.fc-card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 4;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 4;
    }

    function updateActiveCard() {
      if (!cards.length) return;
      var trackRect = track.getBoundingClientRect();
      var trackCenter = trackRect.left + trackRect.width / 2;
      var closest = null;
      var closestDistance = Infinity;

      cards.forEach(function (card) {
        var cardRect = card.getBoundingClientRect();
        var cardCenter = cardRect.left + cardRect.width / 2;
        var distance = Math.abs(cardCenter - trackCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closest = card;
        }
      });

      cards.forEach(function (card) {
        card.classList.toggle('fc-card--activa', card === closest);
      });
    }

    function requestActiveUpdate() {
      if (tickingActive) return;
      tickingActive = true;
      requestAnimationFrame(function () {
        updateActiveCard();
        tickingActive = false;
      });
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', function () {
      updateArrows();
      requestActiveUpdate();
    }, { passive: true });
    window.addEventListener('resize', requestActiveUpdate);
    updateArrows();
    updateActiveCard();
  }

  function popButton(btn) {
    btn.classList.remove('is-popping');
    void btn.offsetWidth; // reflow, para poder relanzar la animación en clics seguidos
    btn.classList.add('is-popping');
  }

  function refreshHeaderCart() {
    return fetch('/cart.js')
      .then(function (res) {
        if (!res.ok) throw new Error('cart refresh failed');
        return res.json();
      })
      .then(function (cart) {
        // El icono del carrito es un componente propio del tema con su
        // lógica de renderizado (clases, animación, sessionStorage); en vez
        // de sustituirlo (lo que le hacía perder su propio estado interno),
        // le pedimos a él mismo que se repinte con el recuento real.
        var cartIcon = document.querySelector('cart-icon');
        if (cartIcon && typeof cartIcon.renderCartBubble === 'function') {
          cartIcon.renderCartBubble(cart.item_count);
        }
      })
      .then(function () {
        return fetch('/?sections=cart-drawer-section', { cache: 'no-store' });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('cart drawer refresh failed');
        return res.json();
      })
      .then(function (data) {
        var html = data && data['cart-drawer-section'];
        if (!html) return;

        var temp = document.createElement('div');
        temp.innerHTML = html;

        // El carrito vive en su propia sección independiente del header;
        // sustituimos el componente completo (lista + totales) por el actual.
        var freshDrawer = temp.querySelector('cart-drawer-component');
        var currentDrawer = document.querySelector('cart-drawer-component');

        if (freshDrawer && currentDrawer) {
          currentDrawer.replaceWith(freshDrawer);
        }
      })
      .catch(function () {
        // Si falla el refresco visual, el producto ya se añadió igualmente al
        // carrito (esto solo actualiza lo que se ve en el panel del header).
      });
  }

  function initAddToCart(section) {
    section.querySelectorAll('.fc-card__btn--view').forEach(function (btn) {
      btn.addEventListener('click', function () {
        popButton(btn);
      });
    });

    var forms = section.querySelectorAll('[data-fc-add-form]');

    forms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var btn = form.querySelector('[data-fc-add-btn]');
        var label = form.querySelector('[data-fc-add-label]');
        if (!btn || btn.disabled) return;

        popButton(btn);
        btn.disabled = true;

        fetch(form.getAttribute('action') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: form.elements['id'].value,
            quantity: parseInt(form.elements['quantity'].value, 10) || 1
          })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add to cart failed');
            return res.json();
          })
          .then(function () {
            btn.classList.add('is-added');
            if (label) label.textContent = btn.dataset.labelDone || '¡Añadido!';

            // Actualiza el número de la burbuja del carrito en el header al instante.
            refreshHeaderCart();

            setTimeout(function () {
              btn.classList.remove('is-added');
              if (label) label.textContent = btn.dataset.labelIdle || 'Añadir al carrito';
              btn.disabled = false;
            }, 1800);
          })
          .catch(function () {
            if (label) label.textContent = 'Error, prueba de nuevo';
            setTimeout(function () {
              if (label) label.textContent = btn.dataset.labelIdle || 'Añadir al carrito';
              btn.disabled = false;
            }, 1800);
          });
      });
    });
  }

  function initFeaturedCollection(section) {
    if (!section || section.dataset.fcInitDone === 'true') return;
    section.dataset.fcInitDone = 'true';

    initReveal(section);
    initSlider(section);
    initAddToCart(section);
  }

  function initAll() {
    document.querySelectorAll('[data-fc-barber]').forEach(initFeaturedCollection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-fc-barber]');
    if (section) {
      section.dataset.fcInitDone = 'false';
      initFeaturedCollection(section);
    }
  });
})();